module.exports = __webpack_public_path__ + "static/I am the Observer and Nature is My Teacher - installation - web-021ff1e77fb12cdd80992f227a94030b.jpg";